import React from "react";
import "./Footer.css";

class Footer extends React.Component {

    render() {
        return (
            <div id="footer">
                <h3>Quick Contact</h3>
                <div id="contact-container">
                    <p>(917) 215-9041</p>
                    <p id="contact-email">rae@kidsinseats.org</p>
                </div>
            </div>
        );
    }
}

export default Footer;